<h3 class="text-overflow">
    <span class="placeholder">
        <i ng-if="isCheckedOut(item)" class="checkedOut" ng-class="statusIcon(item)" title="{{checkOutStatus(item)}}"></i>
    </span>
    <a ng-click="onMainClick(item, $event)">
        <span ng-if="item.rowLock">[{{'changePending'|translate}}]</span>
        <span ng-bind-html="item.Title|cHighlight:highlight"></span>
    </a>
    <a class="details" ng-class="{isFavorite: item.IsFavorite}" ng-click="onFavoritesClick(item, $event)" ng-attr-title="{{ 'workflowList.favorite'|translate }}">
        <i class="fa fa-star-o" ng-if="!item.IsFavorite"></i>
        <i class="fa fa-star isFavorite" ng-if="item.IsFavorite"></i>
    </a>
    <a class="details button" ng-click="onDetailsClick(item, $event)" ng-attr-title="{{ 'workflowList.details'|translate }}">
        <i class="fa fa-info"></i>
    </a>
</h3>
<p ng-bind-html="(item.Abstract ? item.Abstract + '...' : item.Description)|cHighlight:highlight" class="description">
</p>
<span ng-if="hasReferences()" ng-click="showReferencesClick($event)" class="has-references fa fa-link theme-color"></span>
<c-property-list properties="item.itemProperties" highlight="highlight" style="display: inline-block"></c-property-list>
<div ng-if="showDeadline()" class="deadline">{{deadlineText}} <span ng-class="{ 'deadline-exceeded': diffDays<0 }">{{deadline|cDate}}</span> {{daysLeft}}</div>
<div ng-if="isShowingReferences">
    <div class="small-header">{{'linked.workflows'|translate}}</div>
    <div ng-if="references.length == 0" class="no-items">{{"references.noItems"|translate}}</div>
    <c-templated-list items="references"><span class="fa fa-refresh fa-spin" style="color: #a0a0a0;"></span></c-templated-list>
</div>